import moment from 'moment';
import 'moment/min/locales.min'; // for language change of date
import i18n from '../localization';

import SecSeperator from './ui/SecSeperator';
import BreadCrumbs from './ui/BreadCrumbs';

import { IBlogDetailType } from '../redux/types/BlogListTypes';
import { $FIXME, IMAGE_URL } from '../constants';
import { contentAccordToCurrentLang, SetMeta, toCapitalCase } from '../utils/Helper/jsHelpers';
import { addImageFallback } from '../utils/Helper/ImagePlaceholder';

export const formatDate = (date: $FIXME) => {
    if (i18n.language === 'fr') {
        return moment(date).locale('fr').format('dddd DD MMMM YYYY');
    } else {
        return moment(date).format('dddd DD MMMM YYYY');
    }
};

export const dateFormatDate = (date: $FIXME) => {
    if (i18n.language === 'fr') {
        return moment(date).locale('fr').format('DD MMMM YYYY');
    } else {
        return moment(date).format('DD MMMM YYYY');
    }
}
const BlogDetail: React.FC<IBlogDetailType> = (blog) => {
    const date = new Date(blog.createdAt.substring(0, 10));
    return (
        <>
            <SetMeta
                title={contentAccordToCurrentLang(blog).title + '-AUTO24'}
            />
            <div className="blog-detail padding">
                <div className="blog-detail">
                    <BreadCrumbs
                        currentLocation={contentAccordToCurrentLang(blog).title}
                    />
                    <SecSeperator className="blog-details-sep" />
                    <h2 className="title" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                        {contentAccordToCurrentLang(blog).title}
                    </h2>
                    <div className="author-details">
                        <p className="type" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                            <span className='user-icon'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M8 9.99969C10.2091 9.99969 12 8.20883 12 5.99969C12 3.79056 10.2091 1.99969 8 1.99969C5.79086 1.99969 4 3.79056 4 5.99969C4 8.20883 5.79086 9.99969 8 9.99969Z" stroke="#8B8B8B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M1.93677 13.4991C2.55149 12.4351 3.4354 11.5516 4.49969 10.9373C5.56399 10.323 6.77119 9.99968 8.00003 9.99969C9.22886 9.99971 10.4361 10.3231 11.5003 10.9374C12.5646 11.5517 13.4485 12.4352 14.0632 13.4992" stroke="#8B8B8B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </span>
                            {toCapitalCase(blog.author?.name) ?? 'Auto24 Team'}
                        </p>
                        <span>᛫</span>
                        <p className="date" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>{formatDate(date)}</p>
                    </div>
                    <div className="details-section">
                        <div className="blog-detail__image">
                            <img
                                src={IMAGE_URL + blog.image}
                                alt={blog.slug}
                                onError={addImageFallback}
                            />
                        </div>
                        <p
                            className="description"
                            dangerouslySetInnerHTML={{
                                __html:
                                    contentAccordToCurrentLang(blog)
                                        .description ?? 'n/a'
                            }}
                            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        ></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BlogDetail;
